import { Form, Formik, Field } from "formik";
import { observer } from "mobx-react-lite";
import Footer from "../Footer";
import Swal from "sweetalert2";
import * as Yup from "yup";
import React from "react";

import Container from "react-bootstrap/Container";
import { Button, Icon } from "semantic-ui-react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import "./src/css/convenios.css";
import { Link } from "react-router-dom";

import { MyTextAreatConv, MyTextAreatConvD, MyTextInputConv, MyTextInputConvD } from "../../app/common/form/MyTextInput";
import { InstitucionesPublicasNumero } from "../../app/common/options/InstitucionesPublicasConvenio";
import { RegionalBannerCentral } from "../Portafolio/Handlers/RegionalBannerCentral";
import { MySelectInputControl } from "../../app/common/form/MySelectInput";
import { myBreadCrumbsConvRaiz, myBreadCrumbsConvInte } from './Handlers/BreadCrumbsConv';
import UploadFileModal from './Handlers/uploadFilesModal';

const apiURL = process.env.REACT_APP_API_URL + `/CATSolicitudConvenios`;
let activeC: string = "Crear solicitud";
let soliID: any;

export default observer(function CreateSolicitudes( ) {

  const [modalShow, setModalShow] = React.useState(false);

  const getSubmitHandler = (saving: any) => (values: any, formik: any) => {
    const endpoint = saving ? apiURL : apiURL;
    const formData = new FormData();

    for (const key in values) {
      formData.append(key, values[key]);
    }

    return fetch(endpoint, {
      method: "POST",
      body: formData,
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error("Hubo un error");
      }
    }).then(function (data) {
      if (data >= 1) {
        soliID = data;
        return ExitVal();
      }
    })
      .catch(function (error) {
      });
  };

  const validationSchema = Yup.object({

    sgtEntidad: Yup.string()
      .required('Requerido'),
    nombreSolicitante: Yup.string()
      .required('Requerido'),
    nombreResponsable: Yup.string()
      .required('Requerido'),
    telefonoResponsable: Yup.number()
      .min(8, 'Necesitas ingresar 8 digitos como mínimo')
      .required('Requerido'),
    correoResponsable: Yup.string()
      .email('Correo no valido')
      .required('Requerido'),
    descripcion: Yup.string()
      .required('Requerido')
      .min(20, 'Describe bien tu solicitud.')
      .max(300, 'Por favor escribe una descripción más corta.')
  });

  function ExitVal() {

    Swal.fire({
      position: "center",
      showCloseButton: true,
      title: 'Solicitud realizada exitosamente',
      text: "Tu solicitud ha sido generada con exito y los datos ya pueden ser utilizados para crear un nuevo código institucional.",
      icon: 'success',

      showConfirmButton: true,
      confirmButtonText: '¿crear código?',
      confirmButtonAriaLabel: "confirm-button",

      showCancelButton: true,
      cancelButtonText: '¿Cargar archivos?',
      cancelButtonAriaLabel: "confirm-button",

    }).then((result) => {
      if (result.isConfirmed) {
        // window.location.href = `/cargapagos/crear-convenio`;
        window.location.href = `/home/operaciones/:id/CrearConvenio`
      } else if (result.isDismissed) {
        setModalShow(true);
      }
    })
  };

  return (
    <>

      <Container className="solicitudes-area-head head-institu">

        <div className="title-area-institu solicitudes-area-head" >
          <h2>Crear nueva solicitud a código</h2>
        </div>

        <div className="bread-institu-internals">
          {myBreadCrumbsConvInte(activeC)}
        </div>

      </Container>

      <Formik
        onSubmit={(values, { setSubmitting, resetForm, validateForm }) => {
          getSubmitHandler(values);
          setSubmitting(false);
          validateForm(true);
          resetForm();
        }}
        initialValues={{
          nombreSolicitante: "",
          nombreResponsable: "",
          correoResponsable: "",
          telefonoResponsable: "",
          sgtEntidad: "",
          descripcion: "",
          Files: null
        }}
        validationSchema={validationSchema}
      >
        {(formik) => (
          <>

            <Container className="detalle_convenio-area solicitudes-conv-form-area">

              <Row className="convenio-form-area solicitudes-conv-form">

                <div className="form-header">
                  <h3>
                    Llena el siguiente formulario para solicitar un código institucional.
                  </h3>
                </div>

                <Form className="convenio-form ui form">
                  <Row>
                    <Col>

                      <MySelectInputControl
                        label="Entidad"
                        id="sgtEntidad"
                        name="sgtEntidad"
                        placeholder={"- Selecciona una opción -"}
                        options={InstitucionesPublicasNumero}
                      />
                      
                      <MyTextInputConv
                        name="nombreSolicitante"
                        label="Ingresa el nombre del solicitante:"
                        type="input"
                        id="nombreSolicitante"
                        placeholder={"Solicitante"}
                      />
                      <MyTextInputConv
                        name="nombreResponsable"
                        label="Ingresa el nombre del responsable:"
                        type="input"
                        id="nombreResponsable"
                        placeholder={"Ej: Nombres y Apellidos"}
                      />
                      <MyTextInputConv
                        name="correoResponsable"
                        label="Ingresa el correo de la persona responsable:"
                        type="input"
                        id="correoResponsable"
                        placeholder={"Ej: Dirección de Recursos humanos"}
                      />

                      <MyTextInputConv
                        name="telefonoResponsable"
                        label="Ingresa el número de teléfono de la persona responsable:"
                        type="input"
                        id="telefonoResponsable"
                        placeholder={"Ej: 0000 0000"}
                      />

                      <MyTextAreatConv
                        name="descripcion"
                        label="Descripcion de la solicitud"
                        placeholder="Mensaje: "
                        type="input"
                        id="descripcion"
                      />
                    </Col>
                  </Row>

                  <Button
                    disabled={!(formik.isValid && formik.dirty)}
                    variant="primary"
                    onClick={() => { getSubmitHandler({ saving: true })(formik.values, formik.isValid) }}
                  >
                    Guardar
                  </Button>

                </Form>
              </Row>
            </Container>
          </>
        )}
      </Formik>

      <UploadFileModal
        onHide={() => { setModalShow(false) }}
        show={modalShow}
        solicitudID={soliID}
        CType={"CATSolicitudConvenio"}
        insti={null}
      />

    </>
  );
});
